<script lang="ts">
  // Popup cartoon de alerta — 1 botao "OK, entendi". Montado 1x no App.
  // Acionado via showAlert() do stores/alert. Substitui faixas inline feias.
  import { alertState, dismissAlert } from '../../stores/alert';
  import { fly, fade } from 'svelte/transition';

  function onKeydown(e: KeyboardEvent) {
    if ($alertState.open && (e.key === 'Escape' || e.key === 'Enter')) {
      dismissAlert();
    }
  }
</script>

<svelte:window onkeydown={onKeydown} />

{#if $alertState.open}
  <div class="overlay" transition:fade={{ duration: 150 }} onclick={dismissAlert} role="presentation">
    <div
      class="card tone-{$alertState.tone}"
      transition:fly={{ y: 24, duration: 220 }}
      onclick={(e) => e.stopPropagation()}
      role="alertdialog"
      aria-modal="true"
    >
      <div class="icon-badge">
        {#if $alertState.tone === 'warn'}⚠️
        {:else if $alertState.tone === 'error'}🚫
        {:else if $alertState.tone === 'success'}✅
        {:else}ℹ️{/if}
      </div>
      <h3 class="title">{$alertState.title}</h3>
      <p class="message">{$alertState.message}</p>
      <button class="ok-btn" onclick={dismissAlert}>{$alertState.okLabel}</button>
    </div>
  </div>
{/if}

<style>
  .overlay {
    position: fixed;
    inset: 0;
    z-index: 1200;
    background: rgba(2, 3, 26, 0.78);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
  .card {
    width: 100%;
    max-width: 380px;
    background: linear-gradient(180deg, #faf5ec 0%, #fff 60%, #f0e7d5 100%);
    border: 4px solid #1565c0;
    outline: 2px solid #ffb300;
    outline-offset: -3px;
    border-radius: 16px;
    box-shadow: 0 6px 0 #0d3a82, 0 18px 44px rgba(0, 0, 0, 0.45);
    padding: 22px 22px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 10px;
  }
  /* Cor da borda muda por tom */
  .card.tone-warn { border-color: #f9a825; box-shadow: 0 6px 0 #c17900, 0 18px 44px rgba(0, 0, 0, 0.45); }
  .card.tone-error { border-color: #e53935; box-shadow: 0 6px 0 #a52723, 0 18px 44px rgba(0, 0, 0, 0.45); }
  .card.tone-success { border-color: #43a047; box-shadow: 0 6px 0 #2b6a2e, 0 18px 44px rgba(0, 0, 0, 0.45); }

  .icon-badge {
    font-size: 38px;
    line-height: 1;
    margin-top: -2px;
    filter: drop-shadow(0 3px 4px rgba(0, 0, 0, 0.2));
  }
  .title {
    margin: 0;
    font-size: 19px;
    font-weight: 900;
    letter-spacing: 0.5px;
    color: #0d47a1;
    text-transform: uppercase;
  }
  .card.tone-warn .title { color: #c17900; }
  .card.tone-error .title { color: #b71c1c; }
  .card.tone-success .title { color: #2b6a2e; }

  .message {
    margin: 0;
    font-size: 14px;
    line-height: 1.45;
    color: #37474f;
    font-weight: 600;
  }
  .ok-btn {
    margin-top: 8px;
    width: 100%;
    padding: 12px 18px;
    border: 2px solid #0d47a1;
    border-radius: 10px;
    background: linear-gradient(180deg, #42a5f5 0%, #1976d2 50%, #1565c0 100%);
    color: #fff;
    font-size: 14px;
    font-weight: 900;
    letter-spacing: 1px;
    text-transform: uppercase;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.35);
    cursor: pointer;
    box-shadow: 0 3px 0 #0d3a82, inset 0 1px 0 rgba(255, 255, 255, 0.25);
    transition: transform 0.08s, box-shadow 0.08s;
  }
  .ok-btn:hover { transform: translateY(-1px); box-shadow: 0 4px 0 #0d3a82, inset 0 1px 0 rgba(255, 255, 255, 0.25); }
  .ok-btn:active { transform: translateY(2px); box-shadow: 0 1px 0 #0d3a82; }

  .card.tone-warn .ok-btn { background: linear-gradient(180deg, #ffca28, #f9a825 55%, #f57f17); border-color: #c17900; box-shadow: 0 3px 0 #8a5a00, inset 0 1px 0 rgba(255,255,255,0.3); }
  .card.tone-warn .ok-btn:active { box-shadow: 0 1px 0 #8a5a00; }
  .card.tone-error .ok-btn { background: linear-gradient(180deg, #ef5350, #e53935 55%, #c62828); border-color: #a52723; box-shadow: 0 3px 0 #7a1c19, inset 0 1px 0 rgba(255,255,255,0.25); }
  .card.tone-error .ok-btn:active { box-shadow: 0 1px 0 #7a1c19; }
  .card.tone-success .ok-btn { background: linear-gradient(180deg, #66bb6a, #43a047 55%, #2e7d32); border-color: #2b6a2e; box-shadow: 0 3px 0 #1b4d1e, inset 0 1px 0 rgba(255,255,255,0.25); }
  .card.tone-success .ok-btn:active { box-shadow: 0 1px 0 #1b4d1e; }
</style>
